import { App } from 'vue';
import canDirective from './directives/can';
import hasRoleDirective from './directives/hasRole';
import positiveNumberDirective from './directives/positiveNumber';

export default function registerGlobalDirectives(app: App) {
    app.directive('can', canDirective);
    app.directive('hasRole', hasRoleDirective);
    app.directive('positive-number', positiveNumberDirective);
}